<main>
    <div id="content">
        <div class="innerContentWrapper">
            <div class="waiverCard">
                <div layout="column" class="md-inline-form inputLogin">
                    <div class="serverErrorModal">
                        <div class="serverErrorMessage">
                            <h2>Unauthorized Access</h2>
                            <div class="fontDiv">
                                <div class="fontDiv">
                                    Your account does not have access to Partner Center. Please reach out to <span class="underlineThis"> <a href="mailto:{{supportEmail}}"
                                            style="color:#ffff">Partner Center Support </a></span>.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
